
import { VesselMigrationService } from '../services/vessel-migration-service';
import { MigrationChangeEvents, MigrationState, VesselMigrationModelBase } from './vessel-migration-model';

const REFRESH_MIGRATION_STATE_INTERVAL = 1000 * 30; // refresh every 30 seconds

export class VesselMigrationModelImpl extends VesselMigrationModelBase {
    constructor() {
        super();

        this._refreshMigrationState = this._refreshMigrationState.bind(this);
        this.startMigration = this.startMigration.bind(this);

        this._refreshMigrationState();

    }

    private _migrationState: MigrationState | null = null;
    private _interval: any | null = null;

    public get migrationState() {
        return this._migrationState;
    }

    public async startMigration() {
        if (!this._migrationState) {
            await this._refreshMigrationState();
        }

        if (this._migrationState === MigrationState.Windows) {
            await VesselMigrationService.startMigration();
            await this._refreshMigrationState();

            this._interval = setInterval(this._refreshMigrationState, REFRESH_MIGRATION_STATE_INTERVAL)
        }
    }

    private async _refreshMigrationState() {
        // if local development, don't need to call service
        if ((<any>window)["appenv"].isLocal) {
            this._migrationState = MigrationState.LocalDev;
            this.dispatchEvent(new Event(MigrationChangeEvents.StateChanged));
            return;
        }
        const newState = await VesselMigrationService.getMigrationState();
        if (this._migrationState !== newState) {
            this._migrationState = newState;

            // if migration is in progress, create interval to keep checking state changes
            if (!this._interval && this._migrationState === MigrationState.MigrationToNextPlatformInProgress) {
                this._interval = setInterval(this._refreshMigrationState, REFRESH_MIGRATION_STATE_INTERVAL);
            }

            this.dispatchEvent(new Event(MigrationChangeEvents.StateChanged));
        }
    }
}
